// 납입지시 - 협력사재고관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const ROM77 = lazy(() => import('@/pages/A07/ROM77'));
const ROM78 = lazy(() => import('@/pages/A07/ROM78'));
const ROM79 = lazy(() => import('@/pages/A07/ROM79'));
// const ROM3W = lazy(() => import('@/pages/A05/ROM3W'));

function A07() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/A07/ROM77" component={ROM77} />
        <Route path="/A07/ROM78" component={ROM78} />
        <Route path="/A07/ROM79" component={ROM79} />
      </Switch>
    </Suspense>
  );
}

export default A07;
